angular.module('filterAdvanced', [])

  .directive('ghFilterAdvanced', [function () {
    return {
      restrict: 'E',
      scope: {
        fieldModel: '='
      },
      controller: ['$scope', 'Message', function($scope, Message) {
        if (!$scope.filters_list || !$scope.filters_list.length) {
          try {
            if(!$scope.fieldModel.data_model.disable_filter_auto_save || $scope.fieldModel.data_model.disable_filter_auto_save == 0) {
              const filter_list = localStorage.getItem(`filter-list${$scope.fieldModel.field_id}`) || "[]";
              const parsedFiltersList = JSON.parse(filter_list);
              if (parsedFiltersList.length) {
                $scope.filters_list = parsedFiltersList;

                const filters_list = [];
                if($scope.fieldModel.data_model?.user_filter?.length) {
                  for(let i = 0; i < $scope.fieldModel.data_model.user_filter.length; i++) {
                    const filterFields = $scope.fieldModel.data_model.user_filter[i];
                    const filterFromList = $scope.filters_list.find(f => f.field_id == filterFields.field_id);
                    if (filterFromList && filterFields.show) {
                      filters_list.push(filterFromList);
                    }
                  }
                }

                if(filters_list.length > 0) $scope.filters_list = filters_list;

                const timeout = setTimeout(() => {
                  gudhub.emit("filter", { app_id: $scope.fieldModel.data_model.app_id, field_id: $scope.fieldModel.data_model.field_id },  $scope.filters_list);
                  clearTimeout(timeout);
                }, 0);
              }
            }
          } catch (e) {
            console.log(e);
          }
        }
        $scope.filterDataModel = {
          recipient:{
            app_id: $scope.fieldModel.data_model.app_id,
            field_id: $scope.fieldModel.data_model.field_id
          },
          filters_to_view: $scope.fieldModel.data_model.user_filter
        };
      }],
      template: `<gh-filter gh-filter-data-model="filterDataModel" gh-mode="checkbox" field-model="fieldModel" filter-list="filters_list"></gh-filter>`
    }
  }]);